@if (isVisible) {
<div class="beta-modal-backdrop" (click)="onBackdropClick($event)">
  <div class="beta-modal-container" (click)="$event.stopPropagation()">
    <!-- Header -->
    <div class="beta-modal-header">
      <div class="header-content">
        <svg class="beta-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M12 2L13.09 8.26L19 6L14.74 10.91L21 12L14.74 13.09L19 18L13.09 15.74L12 22L10.91 15.74L5 18L9.26 13.09L3 12L9.26 10.91L5 6L10.91 8.26L12 2Z"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
        <h2>Beta Features</h2>
      </div>
      <button class="close-btn" (click)="close()" aria-label="Close modal">
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
      </button>
    </div>

    <!-- Description -->
    <p class="beta-modal-description">
      Enable experimental features to try them before they're officially released. These features are still in development and may change or be removed.
    </p>

    <!-- Features List -->
    <div class="features-list">
      @for (feature of systemFlags(); track feature.id) {
      <div class="feature-item" [class.enabled]="feature.enabled">
        <div class="feature-info">
          <h3 class="feature-name">{{ feature.label }}</h3>
          <p class="feature-description">{{ feature.description }}</p>
        </div>
        <label class="toggle-switch">
          <input type="checkbox" [checked]="feature.enabled" (change)="toggleFeature(feature)" />
          <span class="toggle-slider"></span>
        </label>
      </div>
      }
    </div>
  </div>
</div>
}
